<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>To my dear friend</i></span></p>
<p class="ded1"><span><i>Shirley Chantler</i></span></p>
<p class="ded1"><span><i>with love</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?217d29b4